// Dependencias generales
import React from "react";
import { useEffect } from 'react';
import '../../../css/common.css';
import '../../../css/initialConfigStyle.css';

import Last12BillsAnalysis from '../../Public/Last12BillsAnalysis.js'

const endpointHelias = "https://9m4y8iz04h.execute-api.eu-west-3.amazonaws.com/prod"
const postCompareElectricityFees = endpointHelias+'/Helias/V0/Advisory/postCompareElectricityFees'

var initialConfigCommonJS = require("../../../js/initialConfigCommon.js")
var advisoryCommonJS = require("../../../js/advisoryCommon.js")

// Advisory - Fees Analyzer
const FeesAnalyzer = (params) => {
  
  useEffect(() => {    
    
    inicializar()      

    mostrarFormularioTarifas()    

    actualizarVisibilidadInstalacion2_3()
    actualizarVisibilidadReguladaLibre()
    actualizarVisibilidadConSinPaneles()
    
    console.log("Abro analizador de tarifas.")    
  });

  function inicializar(){

    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "") + " hidden"
    document.getElementById("tablaResultadosInforme").className = document.getElementById("tablaResultadosInforme").className.replaceAll(" hidden", "") + " hidden"    

    document.getElementById("EmailUsuario").value = ""
    document.getElementById("CompañiaActual").value = ""
    document.getElementById("CUPSInstalacion").value = ""
    document.getElementById("selectTipoInstalacion").value = "PISO"
    
    document.getElementById("radioMercadoLibre").checked = true
    document.getElementById("radioMercadoRegulado").checked = false
    
    document.getElementById("radio2_0").checked = true
    document.getElementById("radio3_0").checked = false
    
    document.getElementById("radioSinPaneles").checked = true
    document.getElementById("radioConPaneles").checked = false
    
    document.getElementById("costeOtrosConceptos").value = ""
    document.getElementById("cuotaMensualComercializadora").value = ""
    document.getElementById("costeServicioMonedero").value = ""
    document.getElementById("saldoActualMonedero").value = ""
    document.getElementById("descuentoAnalisis").value = ""
    document.getElementById("costeBonoSocial").value = ""

    for(var x=1;x<7; x++){
      document.getElementById("potenciaP"+x).value = ""
    }

    for(x=1;x<7; x++){
      document.getElementById("potenciaAnalisisEnergiaP"+x).value = ""
    }

    for(x=1;x<7; x++){
      document.getElementById("potenciaMaximaAnualP"+x).value = ""
    }

    for(x=1;x<7; x++){
      document.getElementById("tarifaAnalisisEnergiaP"+x).value = ""
    }

    for(x=1;x<13; x++){
      for(var y=1; y<7; y++){
        document.getElementById("ConsumoMes"+x+"P"+y).value = ""
      }      
    }

    for(x=1;x<13; x++){
      for(y=1; y<7; y++){
        document.getElementById("TarifaMes"+x+"P"+y).value = ""
      }
      
    }

    for(x=1;x<13; x++){
      document.getElementById("ExcedenteMes"+x).value = ""
    }

    for(x=1;x<13; x++){
      document.getElementById("TarifaExcedentesMes"+x).value = ""
    }

    for(x=1;x<13; x++){
      document.getElementById("IVAMes"+x).value = ""
    } 
     
  }

  function mostrarFormularioTarifas(){
      

    document.getElementById("acordeonFormularioAnalisisTarifas").className = document.getElementById("acordeonFormularioAnalisisTarifas").className.replaceAll(" hidden", "")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("open","")
    document.getElementById("acordeonFormularioAnalisisTarifas").setAttribute("disabled","")    
          
    document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" col-lg-2", "") + " col-lg-2"

    document.getElementById("trPotenciaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
    document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

    document.getElementById("trTarifaAnalisisEnergiaP1").className = document.getElementById("trPotenciaAnalisisEnergiaP1").className.replaceAll(" hidden", "")
    document.getElementById("trTarifaAnalisisEnergiaP2").className = document.getElementById("trPotenciaAnalisisEnergiaP2").className.replaceAll(" hidden", "")
    document.getElementById("trTarifaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")
    document.getElementById("trTarifaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
    document.getElementById("trTarifaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
    document.getElementById("trTarifaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")

    document.getElementById("fieldsetDescuento").className = document.getElementById("fieldsetDescuento").className.replaceAll(" hidden", "")
    
    document.getElementById("formularioTarifas").className = document.getElementById("formularioTarifas").className.replaceAll(" hidden", "")
    document.getElementById("tablaResultadosInforme").className = document.getElementById("tablaResultadosInforme").className.replaceAll(" hidden", "") + " hidden"

  }

  function obtenerCampoVerificado(idCampo){

    var campoVerificado = document.getElementById(idCampo).value

    if(campoVerificado !== ""){
      campoVerificado = campoVerificado.replaceAll(",",".").replaceAll(" ","")
    }
    else{
      campoVerificado = 0
    }
    
    return parseFloat(campoVerificado)

  }

  function validarFormulario(){

    document.getElementById("divContenedorDetalleAdvisory").scrollTop = 0

    var lastDashboardData = JSON.parse(localStorage.getItem("lastDashboardData"))
    var numeroPotenciasConfiguradas = lastDashboardData.InstallationData.GeneralInfo.PowerConfiguration.split("#").length

    var numeroErroresValidacion = 0

    document.getElementById("potenciaAnalisisEnergiaP1").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP2").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP3").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP4").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP5").className = ""      
    document.getElementById("potenciaAnalisisEnergiaP6").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP1").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP2").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP3").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP4").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP5").className = ""      
    document.getElementById("tarifaAnalisisEnergiaP6").className = ""          
    document.getElementById("costeServicioMonedero").className = ""      
    document.getElementById("excedenteAnalisis").className = ""      
    document.getElementById("descuentoAnalisis").className = ""      
    //document.getElementById("bonificacionAnalisis").className = ""      
    
    if(numeroPotenciasConfiguradas === 6){ //3.0
    
      for(var x=0;x<6;x++){
        if(document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      for(x=0;x<1;x++){
        if(document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      if(Object.keys(lastDashboardData.FVData).length > 0){
        if(document.getElementById("excedenteAnalisis").value === ""){
          numeroErroresValidacion++
          document.getElementById("excedenteAnalisis").className = "error"
        }
        if(document.getElementById("costeServicioMonedero").value === ""){
          numeroErroresValidacion++
          document.getElementById("costeServicioMonedero").className = "error"
        }
      }

    }
    else{ //2.0

      for(x=0;x<2;x++){
        if(document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("potenciaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      for(x=0;x<1;x++){
        if(document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).value === ""){
          numeroErroresValidacion++
          document.getElementById("tarifaAnalisisEnergiaP"+(x+1)).className = "error"
        }
      }

      if(Object.keys(lastDashboardData.FVData).length > 0){
        if(document.getElementById("excedenteAnalisis").value === ""){
          numeroErroresValidacion++
          document.getElementById("excedenteAnalisis").className = "error"
        }
        if(document.getElementById("costeServicioMonedero").value === ""){
          numeroErroresValidacion++
          document.getElementById("costeServicioMonedero").className = "error"
        }
      }

    }

    if(numeroErroresValidacion > 0){      
      initialConfigCommonJS.mostrarMensajeInformativo("Debes rellenar todos los campos obligatorios.","negative")
      return false
    }
    else{      
      return true
    }

  }

  function generarValorConsumosMes(mes){

    var valorConsumos = ""

    for (var x=1; x < 7; x++){
      if(document.getElementById("ConsumoMes"+mes+"P"+x).value !== ""){
        valorConsumos = valorConsumos + (parseFloat(document.getElementById("ConsumoMes"+mes+"P"+x).value)*1000)
      }
      else{
        valorConsumos = valorConsumos + "0"    
      }

      if( x < 6){
        valorConsumos = valorConsumos + "#"
      }
    }

    return valorConsumos

  }

  function generarValorTarifasMes(mes){

    var valorTarifas = ""

    for (var x=1; x < 7; x++){

      if(document.getElementById("TarifaMes"+mes+"P"+x).value !== ""){
        valorTarifas = valorTarifas + document.getElementById("TarifaMes"+mes+"P"+x).value
      }
      else{
        valorTarifas = valorTarifas + "0"    
      }

      if( x < 6){
        valorTarifas = valorTarifas + "#"
      }
    }

    valorTarifas = valorTarifas.replaceAll(",",".")

    return valorTarifas

  }
 
  function guardarBorrador(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "")
    
    //Payload petición    

    var tipoTarifa = ""

    if(document.getElementById("radioMercadoLibre").checked === true){
      tipoTarifa = "LIBRE"
    }
    else{
      tipoTarifa = "REGULADO"
    }

    var tipoEnergiaInstalacion = ""

    if(document.getElementById("radio2_0").checked === true){
      tipoEnergiaInstalacion = "2.0"
    }
    else{
      tipoEnergiaInstalacion = "3.0"
    }

    var tienePaneles = false

    if(document.getElementById("radioSinPaneles").checked === true){
      tienePaneles = "false"
    }
    else{
      tienePaneles = "true"
    }

    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId"),      
      "draft": {        
        "UserEmail": document.getElementById("EmailUsuario").value,
        "CurrentCompany": document.getElementById("CompañiaActual").value,
        "InstallationElectricCompanyID": document.getElementById("CUPSInstalacion").value.replaceAll(" ", ""),        
        "InstallationType": document.getElementById("selectTipoInstalacion").value,
        "EnergyFeeType": tipoTarifa,
        "InstallationEnergyType": tipoEnergiaInstalacion,
        "FVinInstallation": tienePaneles,
        "ContractedPower": [
          obtenerCampoVerificado("potenciaP1"),
          obtenerCampoVerificado("potenciaP2"),
          obtenerCampoVerificado("potenciaP3"),
          obtenerCampoVerificado("potenciaP4"),
          obtenerCampoVerificado("potenciaP5"),
          obtenerCampoVerificado("potenciaP6")],
        "PowerFees": [
          obtenerCampoVerificado("potenciaAnalisisEnergiaP1"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP2"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP3"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP4"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP5"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP6")],        
        "MaxPowerLastYear": [
          obtenerCampoVerificado("potenciaMaximaAnualP1"),
          obtenerCampoVerificado("potenciaMaximaAnualP2"),
          obtenerCampoVerificado("potenciaMaximaAnualP3"),
          obtenerCampoVerificado("potenciaMaximaAnualP4"),
          obtenerCampoVerificado("potenciaMaximaAnualP5"),
          obtenerCampoVerificado("potenciaMaximaAnualP6")],        
        "EnergyFees": [
          obtenerCampoVerificado("tarifaAnalisisEnergiaP1"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP2"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP3"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP4"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP5"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP6")],
        "MonthlyFees":[
          generarValorTarifasMes(1),
          generarValorTarifasMes(2),
          generarValorTarifasMes(3),
          generarValorTarifasMes(4),
          generarValorTarifasMes(5),
          generarValorTarifasMes(6),
          generarValorTarifasMes(7),
          generarValorTarifasMes(8),
          generarValorTarifasMes(9),
          generarValorTarifasMes(10),
          generarValorTarifasMes(11),
          generarValorTarifasMes(12)
        ],
        "EnergyConsumed": [
          generarValorConsumosMes(1),
          generarValorConsumosMes(2),
          generarValorConsumosMes(3),
          generarValorConsumosMes(4),
          generarValorConsumosMes(5),
          generarValorConsumosMes(6),
          generarValorConsumosMes(7),
          generarValorConsumosMes(8),
          generarValorConsumosMes(9),
          generarValorConsumosMes(10),
          generarValorConsumosMes(11),
          generarValorConsumosMes(12)],        
        "Surplus": [
          obtenerCampoVerificado("ExcedenteMes1"),
          obtenerCampoVerificado("ExcedenteMes2"),
          obtenerCampoVerificado("ExcedenteMes3"),
          obtenerCampoVerificado("ExcedenteMes4"),
          obtenerCampoVerificado("ExcedenteMes5"),
          obtenerCampoVerificado("ExcedenteMes6"),
          obtenerCampoVerificado("ExcedenteMes7"),
          obtenerCampoVerificado("ExcedenteMes8"),
          obtenerCampoVerificado("ExcedenteMes9"),
          obtenerCampoVerificado("ExcedenteMes10"),
          obtenerCampoVerificado("ExcedenteMes11"),
          obtenerCampoVerificado("ExcedenteMes12")
        ],
        "SurplusFees": [
          obtenerCampoVerificado("TarifaExcedentesMes1"),
          obtenerCampoVerificado("TarifaExcedentesMes2"),
          obtenerCampoVerificado("TarifaExcedentesMes3"),
          obtenerCampoVerificado("TarifaExcedentesMes4"),
          obtenerCampoVerificado("TarifaExcedentesMes5"),
          obtenerCampoVerificado("TarifaExcedentesMes6"),
          obtenerCampoVerificado("TarifaExcedentesMes7"),
          obtenerCampoVerificado("TarifaExcedentesMes8"),
          obtenerCampoVerificado("TarifaExcedentesMes9"),
          obtenerCampoVerificado("TarifaExcedentesMes10"),
          obtenerCampoVerificado("TarifaExcedentesMes11"),
          obtenerCampoVerificado("TarifaExcedentesMes12")
        ],
        "Discount": obtenerCampoVerificado("descuentoAnalisis"),        
        "SocialBonus": obtenerCampoVerificado("costeBonoSocial"),
        "SolarWalletBalance": obtenerCampoVerificado("saldoActualMonedero"),            
        "SolarWalletCost": obtenerCampoVerificado("costeServicioMonedero"),            
        "Others": obtenerCampoVerificado("costeOtrosConceptos"),
        "MonthlyCompanyFee": obtenerCampoVerificado("cuotaMensualComercializadora"),        
        "Taxes": [
          obtenerCampoVerificado("IVAMes1"),
          obtenerCampoVerificado("IVAMes2"),
          obtenerCampoVerificado("IVAMes3"),
          obtenerCampoVerificado("IVAMes4"),
          obtenerCampoVerificado("IVAMes5"),
          obtenerCampoVerificado("IVAMes6"),
          obtenerCampoVerificado("IVAMes7"),
          obtenerCampoVerificado("IVAMes8"),
          obtenerCampoVerificado("IVAMes9"),
          obtenerCampoVerificado("IVAMes10"),
          obtenerCampoVerificado("IVAMes11"),
          obtenerCampoVerificado("IVAMes12")
        ]        
      }
    }    

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postCompareElectricityFees, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)

          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }          
          else{                       
            initialConfigCommonJS.mostrarMensajeInformativo("Borrador guardado correctamente.","positive")
            console.log("Borrador guardado correctamente.")
          }            

        }

        if (this.readyState === 4 && this.status !== 200) { 
          initialConfigCommonJS.mostrarMensajeInformativo("Hubo un problema al realizar el análisis de tarifas, vuelve a intentarlo pasados unos minutos.","negative")         
        }        

        document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"
        
      }
      xhttp.send(data); 

  }

  function verificarTarifa(){

    var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
    var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")        
    
    document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "")
    document.getElementById("acordeonCalculosResultados").removeAttribute("open")        
    document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("open")        
    document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("disabled")        

    //Payload petición    

    var tipoTarifa = ""

    if(document.getElementById("radioMercadoLibre").checked === true){
      tipoTarifa = "LIBRE"
    }
    else{
      tipoTarifa = "REGULADO"
    }

    var tipoEnergiaInstalacion = ""

    if(document.getElementById("radio2_0").checked === true){
      tipoEnergiaInstalacion = "2.0"
    }
    else{
      tipoEnergiaInstalacion = "3.0"
    }

    var tienePaneles = false

    if(document.getElementById("radioSinPaneles").checked === true){
      tienePaneles = "false"
    }
    else{
      tienePaneles = "true"
    }

    var jsonPeticion = {
      "accountID": localStorage.getItem("accountID"),
      "installationID": localStorage.getItem("installationId"),
      "analysisData": {        
        "UserEmail": document.getElementById("EmailUsuario").value,
        "CurrentCompany": document.getElementById("CompañiaActual").value,
        "InstallationElectricCompanyID": document.getElementById("CUPSInstalacion").value.replaceAll(" ", ""),        
        "InstallationType": document.getElementById("selectTipoInstalacion").value,
        "EnergyFeeType": tipoTarifa,
        "InstallationEnergyType": tipoEnergiaInstalacion,
        "FVinInstallation": tienePaneles,
        "ContractedPower": [
          obtenerCampoVerificado("potenciaP1"),
          obtenerCampoVerificado("potenciaP2"),
          obtenerCampoVerificado("potenciaP3"),
          obtenerCampoVerificado("potenciaP4"),
          obtenerCampoVerificado("potenciaP5"),
          obtenerCampoVerificado("potenciaP6")],
        "PowerFees": [
          obtenerCampoVerificado("potenciaAnalisisEnergiaP1"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP2"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP3"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP4"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP5"),
          obtenerCampoVerificado("potenciaAnalisisEnergiaP6")],        
        "MaxPowerLastYear": [
          obtenerCampoVerificado("potenciaMaximaAnualP1"),
          obtenerCampoVerificado("potenciaMaximaAnualP2"),
          obtenerCampoVerificado("potenciaMaximaAnualP3"),
          obtenerCampoVerificado("potenciaMaximaAnualP4"),
          obtenerCampoVerificado("potenciaMaximaAnualP5"),
          obtenerCampoVerificado("potenciaMaximaAnualP6")],        
        "EnergyFees": [
          obtenerCampoVerificado("tarifaAnalisisEnergiaP1"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP2"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP3"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP4"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP5"),
          obtenerCampoVerificado("tarifaAnalisisEnergiaP6")],
        "MonthlyFees":[
          generarValorTarifasMes(1),
          generarValorTarifasMes(2),
          generarValorTarifasMes(3),
          generarValorTarifasMes(4),
          generarValorTarifasMes(5),
          generarValorTarifasMes(6),
          generarValorTarifasMes(7),
          generarValorTarifasMes(8),
          generarValorTarifasMes(9),
          generarValorTarifasMes(10),
          generarValorTarifasMes(11),
          generarValorTarifasMes(12)
        ],
        "EnergyConsumed": [
          generarValorConsumosMes(1),
          generarValorConsumosMes(2),
          generarValorConsumosMes(3),
          generarValorConsumosMes(4),
          generarValorConsumosMes(5),
          generarValorConsumosMes(6),
          generarValorConsumosMes(7),
          generarValorConsumosMes(8),
          generarValorConsumosMes(9),
          generarValorConsumosMes(10),
          generarValorConsumosMes(11),
          generarValorConsumosMes(12)],        
        "Surplus": [
          obtenerCampoVerificado("ExcedenteMes1"),
          obtenerCampoVerificado("ExcedenteMes2"),
          obtenerCampoVerificado("ExcedenteMes3"),
          obtenerCampoVerificado("ExcedenteMes4"),
          obtenerCampoVerificado("ExcedenteMes5"),
          obtenerCampoVerificado("ExcedenteMes6"),
          obtenerCampoVerificado("ExcedenteMes7"),
          obtenerCampoVerificado("ExcedenteMes8"),
          obtenerCampoVerificado("ExcedenteMes9"),
          obtenerCampoVerificado("ExcedenteMes10"),
          obtenerCampoVerificado("ExcedenteMes11"),
          obtenerCampoVerificado("ExcedenteMes12")
        ],
        "SurplusFees": [
          obtenerCampoVerificado("TarifaExcedentesMes1"),
          obtenerCampoVerificado("TarifaExcedentesMes2"),
          obtenerCampoVerificado("TarifaExcedentesMes3"),
          obtenerCampoVerificado("TarifaExcedentesMes4"),
          obtenerCampoVerificado("TarifaExcedentesMes5"),
          obtenerCampoVerificado("TarifaExcedentesMes6"),
          obtenerCampoVerificado("TarifaExcedentesMes7"),
          obtenerCampoVerificado("TarifaExcedentesMes8"),
          obtenerCampoVerificado("TarifaExcedentesMes9"),
          obtenerCampoVerificado("TarifaExcedentesMes10"),
          obtenerCampoVerificado("TarifaExcedentesMes11"),
          obtenerCampoVerificado("TarifaExcedentesMes12")
        ],
        "Discount": obtenerCampoVerificado("descuentoAnalisis"),        
        "SocialBonus": obtenerCampoVerificado("costeBonoSocial"),
        "SolarWalletBalance": obtenerCampoVerificado("saldoActualMonedero"),            
        "SolarWalletCost": obtenerCampoVerificado("costeServicioMonedero"),            
        "Others": obtenerCampoVerificado("costeOtrosConceptos"),
        "MonthlyCompanyFee": obtenerCampoVerificado("cuotaMensualComercializadora"),        
        "Taxes": [
          obtenerCampoVerificado("IVAMes1"),
          obtenerCampoVerificado("IVAMes2"),
          obtenerCampoVerificado("IVAMes3"),
          obtenerCampoVerificado("IVAMes4"),
          obtenerCampoVerificado("IVAMes5"),
          obtenerCampoVerificado("IVAMes6"),
          obtenerCampoVerificado("IVAMes7"),
          obtenerCampoVerificado("IVAMes8"),
          obtenerCampoVerificado("IVAMes9"),
          obtenerCampoVerificado("IVAMes10"),
          obtenerCampoVerificado("IVAMes11"),
          obtenerCampoVerificado("IVAMes12")
        ]        
      }
    }    

    // Guardo la información  
    var xhttp = new XMLHttpRequest();  
      xhttp.open("POST", postCompareElectricityFees, true);        
      xhttp.setRequestHeader('Content-Type', "application/json");
      xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
      var data = JSON.stringify(jsonPeticion);
      xhttp.onreadystatechange = function() {
        if (this.readyState === 4 && this.status === 200) {
          var jsonRespuesta = JSON.parse(this.responseText)

          if(jsonRespuesta.statusCode === "403"){                   
            initialConfigCommonJS.mostrarMensajeInformativo("No tiene permisos para realizar la operación.","negative")
          }          
          else{           
            
            document.getElementById("BotonEnviarAnalisis").className = document.getElementById("BotonEnviarAnalisis").className.replaceAll(" hidden", "")
            document.getElementById("BotonEnviarAnalisis").innerHTML = "Enviar análisis a "+document.getElementById("EmailUsuario").value
            
            advisoryCommonJS.procesarRespuestaVerificacion(jsonRespuesta)
            console.log("Análisis de tarifas realizado correctamente.")
          }            

        }

        if (this.readyState === 4 && this.status !== 200) { 
          initialConfigCommonJS.mostrarMensajeInformativo("Hubo un problema al realizar el análisis de tarifas, vuelve a intentarlo pasados unos minutos.","negative")         
        }        

        document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"
        
      }
      xhttp.send(data); 

  }

  function actualizarVisibilidadInstalacion2_3(){

    var x = 0
    var y = 0

    if(document.getElementById("radio2_0").checked){

      document.getElementById("trDatosPotenciaP3").className = document.getElementById("trDatosPotenciaP3").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaMaximaAnualP3").className = document.getElementById("trPotenciaMaximaAnualP3").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "") + " hidden"
            
      document.getElementById("trDatosPotenciaP4").className = document.getElementById("trDatosPotenciaP4").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaMaximaAnualP4").className = document.getElementById("trPotenciaMaximaAnualP4").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "") + " hidden"
      
      document.getElementById("trDatosPotenciaP5").className = document.getElementById("trDatosPotenciaP5").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaMaximaAnualP5").className = document.getElementById("trPotenciaMaximaAnualP5").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "") + " hidden"
      
      document.getElementById("trDatosPotenciaP6").className = document.getElementById("trDatosPotenciaP6").className.replaceAll(" hidden", "") + " hidden"
      document.getElementById("trPotenciaMaximaAnualP6").className = document.getElementById("trPotenciaMaximaAnualP6").className.replaceAll(" hidden", "") + " hidden"            
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "") + " hidden"
      
      document.getElementById("fieldsetPotencias").className = "columns col-lg-2"
      document.getElementById("fieldsetCamposTarifasEnergia").className = "columns col-lg-4"
            
      for (x=4; x<7; x++){        
        
        document.getElementById("trTarifaAnalisisEnergiaP"+x).className = document.getElementById("trTarifaAnalisisEnergiaP"+x).className.replaceAll(" hidden", "") + " hidden"        
        
        for(y=1; y<13; y++){

          document.getElementById("fieldsetExcedentesIVAM"+y).className = "columns col-lg-4"
          document.getElementById("fieldsetConsumosM"+y).className = "columns col-lg-4"
          document.getElementById("trConsumosMes"+y+"P"+x).className = document.getElementById("trConsumosMes"+y+"P"+x).className.replaceAll(" hidden", "") + " hidden"          
          document.getElementById("fieldsetTarifasM"+y).className = "columns col-lg-4"          
          document.getElementById("trTarifaMes"+y+"P"+x).className = document.getElementById("trConsumosMes"+y+"P"+x).className.replaceAll(" hidden", "") + " hidden"          

        }

      }

    }
    else{

      document.getElementById("trDatosPotenciaP3").className = document.getElementById("trDatosPotenciaP3").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaMaximaAnualP3").className = document.getElementById("trPotenciaMaximaAnualP3").className.replaceAll(" hidden", "")            
      document.getElementById("trPotenciaAnalisisEnergiaP3").className = document.getElementById("trPotenciaAnalisisEnergiaP3").className.replaceAll(" hidden", "")      
      
      document.getElementById("trDatosPotenciaP4").className = document.getElementById("trDatosPotenciaP4").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaMaximaAnualP4").className = document.getElementById("trPotenciaMaximaAnualP4").className.replaceAll(" hidden", "")            
      document.getElementById("trPotenciaAnalisisEnergiaP4").className = document.getElementById("trPotenciaAnalisisEnergiaP4").className.replaceAll(" hidden", "")
      
      document.getElementById("trDatosPotenciaP5").className = document.getElementById("trDatosPotenciaP5").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaMaximaAnualP5").className = document.getElementById("trPotenciaMaximaAnualP5").className.replaceAll(" hidden", "")            
      document.getElementById("trPotenciaAnalisisEnergiaP5").className = document.getElementById("trPotenciaAnalisisEnergiaP5").className.replaceAll(" hidden", "")
      
      document.getElementById("trDatosPotenciaP6").className = document.getElementById("trDatosPotenciaP6").className.replaceAll(" hidden", "")
      document.getElementById("trPotenciaMaximaAnualP6").className = document.getElementById("trPotenciaMaximaAnualP6").className.replaceAll(" hidden", "")            
      document.getElementById("trPotenciaAnalisisEnergiaP6").className = document.getElementById("trPotenciaAnalisisEnergiaP6").className.replaceAll(" hidden", "")
      
      document.getElementById("fieldsetPotencias").className = "columns col-lg-6"
      document.getElementById("fieldsetCamposTarifasEnergia").className = "columns col-lg-7"
      
      for (x=4; x<7; x++){        
        
        document.getElementById("trTarifaAnalisisEnergiaP"+x).className = document.getElementById("trTarifaAnalisisEnergiaP"+x).className.replaceAll(" hidden", "")
                
        for(y=1; y<13; y++){

          document.getElementById("fieldsetExcedentesIVAM"+y).className = "columns col-lg-7"
          document.getElementById("fieldsetConsumosM"+y).className = "columns col-lg-7" 
          document.getElementById("trConsumosMes"+y+"P"+x).className = document.getElementById("trConsumosMes"+y+"P"+x).className.replaceAll(" hidden", "")
          document.getElementById("fieldsetTarifasM"+y).className = "columns col-lg-7"          
          document.getElementById("trTarifaMes"+y+"P"+x).className = document.getElementById("trConsumosMes"+y+"P"+x).className.replaceAll(" hidden", "")
          
        }

      }

    }

    actualizarVisibilidadReguladaLibre()

  }

  function actualizarVisibilidadReguladaLibre(){

    var x=0
    var y=0

    if(document.getElementById("radioMercadoRegulado").checked){

      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" hidden", "") + " hidden"
            
      for (x=1; x<7; x++){
        
        for (y=1; y<13; y++){
          document.getElementById("fieldsetTarifasM"+y).className = document.getElementById("fieldsetTarifasM"+y).className.replaceAll(" hidden", "")          
        }

      }      
    
    }
    else{ // Mercado libre

      document.getElementById("fieldsetCamposTarifasEnergia").className = document.getElementById("fieldsetCamposTarifasEnergia").className.replaceAll(" hidden", "")
            
      for (x=1; x<7; x++){
        
        for (y=1; y<13; y++){
          document.getElementById("fieldsetTarifasM"+y).className = document.getElementById("fieldsetTarifasM"+y).className.replaceAll(" hidden", "") + " hidden"
        }

      }

    }

  }

  function actualizarVisibilidadConSinPaneles(){

    var y=0

    if(document.getElementById("radioConPaneles").checked){
      
      document.getElementById("fieldsetOtros").className = "columns col-lg-7"
            
      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "")          
            
      document.getElementById("spanTituloSaldoMonedero").innerHTML = "Saldo actual monedero"
      document.getElementById("fieldsetSaldoActualMonedero").className = document.getElementById("fieldsetSaldoActualMonedero").className.replaceAll(" hidden", "")          
      
      for (y=1; y<13; y++){
        document.getElementById("trExcedentesMes"+y).className = document.getElementById("trExcedentesMes"+y).className.replaceAll(" hidden", "")                  
        document.getElementById("trTarifaExcedentesMes"+y).className = document.getElementById("trTarifaExcedentesMes"+y).className.replaceAll(" hidden", "")                  
      }

    }
    else{ // Sin paneles

      document.getElementById("fieldsetOtros").className = "columns col-lg-6"

      document.getElementById("fieldsetCosteServicioMonedero").className = document.getElementById("fieldsetCosteServicioMonedero").className.replaceAll(" hidden", "") + " hidden"    
      
      document.getElementById("spanTituloSaldoMonedero").innerHTML = "Saldo bonificaciones"
      document.getElementById("fieldsetSaldoActualMonedero").className = document.getElementById("fieldsetSaldoActualMonedero").className.replaceAll(" hidden", "")
      
      for (y=1; y<13; y++){
        document.getElementById("trExcedentesMes"+y).className = document.getElementById("trExcedentesMes"+y).className.replaceAll(" hidden", "") + " hidden"        
        
        document.getElementById("trTarifaExcedentesMes"+y).className = document.getElementById("trTarifaExcedentesMes"+y).className.replaceAll(" hidden", "") + " hidden"              
        document.getElementById("TarifaExcedentesMes"+y).value = ""        
        
      }

    }

  }

  function comprobarAnalisisPrevio(){

    if( (document.getElementById("CUPSInstalacion").value !== "") ){

      document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") 

      var lastAuthUser = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74.LastAuthUser")
      var lastAuthUserIdToken = localStorage.getItem("CognitoIdentityServiceProvider.6m59dtig38s2dgvqdngechft74."+lastAuthUser+".idToken")       
      var jsonPeticion = {
        "accountID": localStorage.getItem("accountID"),
        "installationID": localStorage.getItem("installationId"),
        "checkAnalysis": document.getElementById("CUPSInstalacion").value.replaceAll(" ", ""),
        "email": document.getElementById("EmailUsuario").value
      }
      
      var xhttp = new XMLHttpRequest();  
        xhttp.open("POST", postCompareElectricityFees, true);        
        xhttp.setRequestHeader('Content-Type', "application/json");
        xhttp.setRequestHeader('Authorization', lastAuthUserIdToken);
        var data = JSON.stringify(jsonPeticion);
        xhttp.onreadystatechange = function() {
          if (this.readyState === 4 && this.status === 200) {

            var jsonRespuesta = JSON.parse(this.responseText)

            if(jsonRespuesta.body.length !== 0){

              if(jsonRespuesta.body[0].MaxRequestedReports === undefined){
                jsonRespuesta = jsonRespuesta.body[0]

                document.getElementById("EmailUsuario").value = jsonRespuesta.INPUT.analysisData.UserEmail
                document.getElementById("CompañiaActual").value = jsonRespuesta.INPUT.analysisData.CurrentCompany                
                document.getElementById("CUPSInstalacion").value = jsonRespuesta.INPUT.analysisData.InstallationElectricCompanyID
                document.getElementById("selectTipoInstalacion").value = jsonRespuesta.INPUT.analysisData.InstallationType

                var textoBotonEnviar = ""
                var ultimaAccion = ""

                if(jsonRespuesta.STATUS === "Reviewing"){
                  textoBotonEnviar = "<strong>[ ESTADO: EN REVISIÓN ]</strong> Enviar análisis a "+document.getElementById("EmailUsuario").value
                  ultimaAccion = "REVISADO"                
                }
                else if(jsonRespuesta.STATUS === "Draft"){
                  textoBotonEnviar = "<strong>[ ESTADO: BORRADOR ]</strong>"
                  ultimaAccion = "GUARDADO COMO BORRADOR"
                }            
                else if(jsonRespuesta.STATUS === "Sent"){
                  textoBotonEnviar = "<strong>[ ESTADO: ENVIADO ]</strong> Re-enviar análisis a "+document.getElementById("EmailUsuario").value
                  ultimaAccion = "ENVIADO"
                }            
                else if(jsonRespuesta.STATUS === "Accepted"){
                  textoBotonEnviar = "<strong>[ ESTADO: ACEPTADO ]</strong> Enviar análisis a "+document.getElementById("EmailUsuario").value
                  ultimaAccion = "ACEPTADO"
                }
                else if(jsonRespuesta.STATUS === "Free"){
                  textoBotonEnviar = "<strong>[ ESTADO: ANÁLISIS GRATIS - ENVIADO]</strong> Enviar análisis a "+document.getElementById("EmailUsuario").value
                  ultimaAccion = "ACEPTADO"
                }
                else if(jsonRespuesta.STATUS === "NoSavings"){
                  textoBotonEnviar = "<strong>[ ESTADO: SIN AHORRO - ENVIADO]</strong> Enviar análisis a "+document.getElementById("EmailUsuario").value
                  ultimaAccion = "ACEPTADO"
                }

                document.getElementById("BotonEnviarAnalisis").innerHTML = textoBotonEnviar
      
                if(jsonRespuesta.INPUT.analysisData.EnergyFeeType === "REGULADO"){
                  document.getElementById("radioMercadoLibre").checked = false
                  document.getElementById("radioMercadoRegulado").checked = true
                }
                else{
                  document.getElementById("radioMercadoLibre").checked = true
                  document.getElementById("radioMercadoRegulado").checked = false
                }

                if(jsonRespuesta.INPUT.analysisData.InstallationEnergyType === "2.0"){
                  document.getElementById("radio2_0").checked = true
                  document.getElementById("radio3_0").checked = false
                }
                else{
                  document.getElementById("radio2_0").checked = false
                  document.getElementById("radio3_0").checked = true
                }
                
                if(jsonRespuesta.INPUT.analysisData.FVinInstallation === "true"){
                  document.getElementById("radioSinPaneles").checked = false
                  document.getElementById("radioConPaneles").checked = true
                }
                else{
                  document.getElementById("radioSinPaneles").checked = true
                  document.getElementById("radioConPaneles").checked = false
                }
                
                document.getElementById("costeOtrosConceptos").value = jsonRespuesta.INPUT.analysisData.Others.replaceAll(".",",")
                document.getElementById("cuotaMensualComercializadora").value = jsonRespuesta.INPUT.analysisData.MonthlyCompanyFee.replaceAll(".",",")
                document.getElementById("costeServicioMonedero").value = jsonRespuesta.INPUT.analysisData.SolarWalletCost.replaceAll(".",",")
                document.getElementById("saldoActualMonedero").value = jsonRespuesta.INPUT.analysisData.SolarWalletBalance.replaceAll(".",",")
                document.getElementById("descuentoAnalisis").value = jsonRespuesta.INPUT.analysisData.Discount.replaceAll(".",",")
                document.getElementById("costeBonoSocial").value = jsonRespuesta.INPUT.analysisData.SocialBonus.replaceAll(".",",")

                for(var x=1;x<(jsonRespuesta.INPUT.analysisData.ContractedPower.length + 1); x++){
                  document.getElementById("potenciaP"+x).value = jsonRespuesta.INPUT.analysisData.ContractedPower[x-1].replaceAll(".",",")
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.PowerFees.length + 1); x++){
                  document.getElementById("potenciaAnalisisEnergiaP"+x).value = jsonRespuesta.INPUT.analysisData.PowerFees[x-1].replaceAll(".",",")
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.MaxPowerLastYear.length + 1); x++){
                  document.getElementById("potenciaMaximaAnualP"+x).value = jsonRespuesta.INPUT.analysisData.MaxPowerLastYear[x-1].replaceAll(".",",")
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.EnergyFees.length + 1); x++){
                  document.getElementById("tarifaAnalisisEnergiaP"+x).value = jsonRespuesta.INPUT.analysisData.EnergyFees[x-1].replaceAll(".",",")
                }

                var consumoMesTemp = ""

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.EnergyConsumed.length + 1); x++){

                  consumoMesTemp = jsonRespuesta.INPUT.analysisData.EnergyConsumed[x-1].split("#")

                  for(var y=1; y<(consumoMesTemp.length+1); y++){
                    document.getElementById("ConsumoMes"+x+"P"+y).value = (parseFloat(consumoMesTemp[y-1])/1000).toString().replaceAll(".",",")
                  }
                  
                }

                var tarifaMesTemp = ""
                
                for(x=1;x<(jsonRespuesta.INPUT.analysisData.MonthlyFees.length + 1); x++){

                  tarifaMesTemp = jsonRespuesta.INPUT.analysisData.MonthlyFees[x-1].split("#")

                  for(y=1; y<(tarifaMesTemp.length+1); y++){
                    document.getElementById("TarifaMes"+x+"P"+y).value = tarifaMesTemp[y-1].replaceAll(".",",")
                  }
                  
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.Surplus.length + 1); x++){
                  document.getElementById("ExcedenteMes"+x).value = jsonRespuesta.INPUT.analysisData.Surplus[x-1].replaceAll(".",",")
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.SurplusFees.length + 1); x++){
                  document.getElementById("TarifaExcedentesMes"+x).value = jsonRespuesta.INPUT.analysisData.SurplusFees[x-1].replaceAll(".",",")
                }

                for(x=1;x<(jsonRespuesta.INPUT.analysisData.Taxes.length + 1); x++){
                  document.getElementById("IVAMes"+x).value = jsonRespuesta.INPUT.analysisData.Taxes[x-1].replaceAll(".",",")
                }

                actualizarVisibilidadInstalacion2_3()
                actualizarVisibilidadReguladaLibre()
                actualizarVisibilidadConSinPaneles()            

                if(jsonRespuesta.STATUS !== "Draft"){
                  jsonRespuesta.body = jsonRespuesta.OUTPUT

                  advisoryCommonJS.procesarRespuestaVerificacion(jsonRespuesta)

                  document.getElementById("acordeonCalculosResultados").removeAttribute("open")        
                  document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("open")        
                  document.getElementById("acordeonFormularioAnalisisTarifas").removeAttribute("disabled")        
                }
                else{
                  document.getElementById("tablaResultadosInforme").className = document.getElementById("tablaResultadosInforme").className.replaceAll(" hidden", "") + " hidden"
                }                
                
                var dateTimeAnalisis = jsonRespuesta.DATE
                var fecha = dateTimeAnalisis.split("T")[0]
                var elementosFecha = fecha.split("-")
                fecha = elementosFecha[2]+"/"+elementosFecha[1]+"/"+elementosFecha[0]
                var hora = dateTimeAnalisis.split("T")[1]
                var elementosHora = hora.split(":")
                hora = elementosHora[0]+":"+elementosHora[1]

                initialConfigCommonJS.mostrarMensajeInformativo("Este CUPS fue "+ultimaAccion+" el "+fecha+" a las "+hora+".","positive")

                if(jsonRespuesta.STATUS !== "Draft"){
                  document.getElementById("BotonEnviarAnalisis").className = document.getElementById("BotonEnviarAnalisis").className.replaceAll(" hidden", "")
                }
                else{
                  document.getElementById("BotonEnviarAnalisis").className = document.getElementById("BotonEnviarAnalisis").className.replaceAll(" hidden", "") + " hidden"
                }
              }
              else{
                var mensajeInformativo = "Este usuario tiene "+jsonRespuesta.body[0].MaxRequestedReports+" informes en HELIAS y ha alcanzado el límite de solicitudes en el último año."

                if(jsonRespuesta.body[0].TrialInstallations > 0){
                  mensajeInformativo = mensajeInformativo + " Este usuario tiene "+jsonRespuesta.body[0].HeliasInstalations+" instalaciones en Helias y "+jsonRespuesta.body[0].TrialInstallations+" en periodo de prueba."
                }

                initialConfigCommonJS.mostrarMensajeInformativo(mensajeInformativo,"info")
              }

            }
            else{
              
              initialConfigCommonJS.mostrarMensajeInformativo("Este CUPS no ha sido analizado en el último año.","info")
              
              var CUPSActual = document.getElementById("CUPSInstalacion").value
              var EmailActual = document.getElementById("EmailUsuario").value

              // Inicializar todos los campos menos el CUPS
              inicializar()      

              mostrarFormularioTarifas()    

              actualizarVisibilidadInstalacion2_3()
              actualizarVisibilidadReguladaLibre()
              actualizarVisibilidadConSinPaneles()              

              document.getElementById("CUPSInstalacion").value = CUPSActual
              document.getElementById("EmailUsuario").value = EmailActual

              document.getElementById("BotonEnviarAnalisis").className = document.getElementById("BotonEnviarAnalisis").className.replaceAll(" hidden", "") + " hidden"

            }

            

            document.getElementById("loaderGeneralAplicacion").className = document.getElementById("loaderGeneralAplicacion").className.replaceAll(" hidden", "") + " hidden"

          }
        }
        xhttp.send(data);
    }
    else{
      initialConfigCommonJS.mostrarMensajeInformativo("Introduce al menos el CUPS.","info")
    }
    
  }

  return (      
    <div id="divContenedorDetalleAdvisory" className="wrapper">

      <div className="page">

        <div id="formularioTarifas" className="vertical">

          <div className="accordion-wrapper" >

            <details id="acordeonFormularioAnalisisTarifas" className="accordion" open disabled>
              
              <summary className="title">
                <figure className="avatar size-l green">
                  <span className="material-icon">euro</span>
                </figure>
                <h1 id="tituloComparativa" className="size-l">Datos del análisis</h1>                
              </summary>

              <fieldset className="accordion-content vertical gap-08">              
              
                  <span className="size-l">Datos usuario</span>

                  <fieldset className="columns col-lg-3">

                    <fieldset className="text">
                      <label htmlFor="name">CUPS</label>
                      <input type="text" id="CUPSInstalacion"/>
                    </fieldset>    

                    <fieldset className="text">
                      <label htmlFor="name">Email usuario</label>
                      <input type="text" id="EmailUsuario"/>
                    </fieldset>

                    <fieldset className="horizontal ">
                      <a href="#BotoneraFormulario" className="button tertiary" style={{height: "48px", alignSelf: "flex-end", marginBottom: "2px"}}>Bajar</a>
                      <button className="button primary full-width" style={{height: "48px", alignSelf: "flex-end", marginBottom: "2px"}} onClick={() => comprobarAnalisisPrevio()}>Comprobar</button>                      
                    </fieldset>

                  </fieldset>

                  <div id="mensaje12FacturasVersionPrueba" className="message info">
                    <p className="size-s">Comprobar primero el CUPS sin email y luego comprobar de nuevo con email.</p>
                  </div>

                  <fieldset className="columns col-lg-2">                    

                    <fieldset className="text">
                      <label htmlFor="name">Compañia actual</label>
                      <input type="text" id="CompañiaActual"/>
                    </fieldset>
                    
                    <fieldset style={{marginTop: "-8px"}}>
                      <legend>Tipo de instalación</legend>
                      <fieldset className="dropdown">                
                        <div className="icon-wrapper">
                          <select id="selectTipoInstalacion">
                            <option value="PISO">Piso</option>
                            <option value="CHALET">Chalet</option>
                            <option value="EMPRESA">Empresa</option>
                            <option value="COMUNIDAD">Comunidad de vecinos</option>                    
                          </select>
                        </div>
                      </fieldset> 
                    </fieldset>
                  </fieldset>

                  <fieldset className="columns col-lg-3">

                    <fieldset className="horizontal center">
                      <input type="radio" id="radio2_0" name="Instalacion2_0-3_0" defaultChecked onChange={() => actualizarVisibilidadInstalacion2_3()} />
                      <label htmlFor="radio2_0" className="">                      
                        <span className="label">Instalación 2.0</span>
                      </label>

                      <input type="radio" id="radio3_0" name="Instalacion2_0-3_0" onChange={() => actualizarVisibilidadInstalacion2_3()} />
                      <label htmlFor="radio3_0" className="">                      
                        <span className="label">Instalación 3.0</span>
                      </label>
                    </fieldset>

                    <fieldset className="horizontal center">
                      <input type="radio" id="radioMercadoLibre" name="TipoMercado" defaultChecked onChange={() => actualizarVisibilidadReguladaLibre()} />
                      <label htmlFor="radioMercadoLibre" className="">                      
                        <span className="label">Mercado libre</span>
                      </label>

                      <input type="radio" id="radioMercadoRegulado" name="TipoMercado" onChange={() => actualizarVisibilidadReguladaLibre()} />
                      <label htmlFor="radioMercadoRegulado" className="">                      
                        <span className="label">Mercado regulado</span>
                      </label>
                    </fieldset>

                    <fieldset className="horizontal center">
                      <input type="radio" id="radioSinPaneles" name="tieneONoPaneles" defaultChecked onChange={() => actualizarVisibilidadConSinPaneles()} />
                      <label htmlFor="radioSinPaneles" className="">                      
                        <span className="label">Sin paneles</span>
                      </label>

                      <input type="radio" id="radioConPaneles" name="tieneONoPaneles"  onChange={() => actualizarVisibilidadConSinPaneles()} />
                      <label htmlFor="radioConPaneles" className="">                      
                        <span className="label">Con paneles</span>
                      </label>
                    </fieldset>
                  
                  </fieldset>

              <fieldset>
                  <span className="size-l">POTENCIAS Y TARIFAS</span>
                  
                  <fieldset id="fieldsetPotencias" className="columns col-lg-6">
                  
                    <fieldset id="trDatosPotenciaP1">
                      <label htmlFor="potenciaP1">Potencia P1</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP1" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>
                  
                    <fieldset id="trDatosPotenciaP2">
                      <label htmlFor="potenciaP2">Potencia P2</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP2" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>
                  
                    <fieldset id="trDatosPotenciaP3">
                      <label htmlFor="potenciaP3">Potencia P3</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP3" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trDatosPotenciaP4">
                      <label htmlFor="potenciaP4">Potencia P4</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP4" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trDatosPotenciaP5">
                      <label htmlFor="potenciaP5">Potencia P5</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP5" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trDatosPotenciaP6">
                      <label htmlFor="potenciaP6">Potencia P6</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaP6" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaAnalisisEnergiaP1">
                      <label htmlFor="potenciaAnalisisEnergiaP1">Tarifa P1</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP1" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaAnalisisEnergiaP2">
                      <label htmlFor="potenciaAnalisisEnergiaP2">Tarifa P2</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP2" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>
                  
                    <fieldset id="trPotenciaAnalisisEnergiaP3">
                      <label htmlFor="potenciaAnalisisEnergiaP3">Tarifa P3</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP3" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaAnalisisEnergiaP4">
                      <label htmlFor="potenciaAnalisisEnergiaP4">Tarifa P4</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP4" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaAnalisisEnergiaP5">
                      <label htmlFor="potenciaAnalisisEnergiaP5">Tarifa P5</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP5" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaAnalisisEnergiaP6">
                      <label htmlFor="potenciaAnalisisEnergiaP6">Tarifa P6</label>
                      <fieldset className="icon-wrapper data" data-label="€/kW/día">
                        <input id="potenciaAnalisisEnergiaP6" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaMaximaAnualP1">
                      <label htmlFor="potenciaMaximaAnualP1">P1 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP1" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaMaximaAnualP2">
                      <label htmlFor="potenciaMaximaAnualP2">P2 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP2" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>
                  
                    <fieldset id="trPotenciaMaximaAnualP3">
                      <label htmlFor="potenciaMaximaAnualP3">P3 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP3" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaMaximaAnualP4">
                      <label htmlFor="potenciaMaximaAnualP4">P4 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP4" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaMaximaAnualP5">
                      <label htmlFor="potenciaMaximaAnualP5">P5 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP5" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trPotenciaMaximaAnualP6">
                      <label htmlFor="potenciaMaximaAnualP6">P6 máxima anual</label>
                      <fieldset className="icon-wrapper data" data-label="kW">
                        <input id="potenciaMaximaAnualP6" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                  </fieldset>

                </fieldset>

                <fieldset>
                  <span className="size-l">OTROS</span>   

                  <fieldset id="fieldsetOtros" className="columns col-lg-7">

                    <fieldset className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">AUTOCALCULADOS: Bono social, Impuesto electricidad</span>
                        </span>                        
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetOtrosConceptos" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Otros: Alquiler...</span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€/Día">
                          <input type="text" inputMode="decimal" id="costeOtrosConceptos" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetCosteBonoSocial" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Coste bono social</span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€/Día">
                          <input type="text" inputMode="decimal" id="costeBonoSocial" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>
                    
                    <fieldset id="fieldsetCosteServicioMonedero" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Coste monedero</span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€/Mes">
                          <input type="text" inputMode="decimal" id="costeServicioMonedero" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetSaldoActualMonedero" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span id="spanTituloSaldoMonedero"className="tooltip-label"></span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€">
                          <input type="text" inputMode="decimal" id="saldoActualMonedero" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetDescuento" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Descuento</span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input type="text" inputMode="decimal" id="descuentoAnalisis" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetCuotaMensualComercializadora" className="tooltip-parent">
                      <fieldset>
                        <span className="size-xs clarification has-tooltip">
                          <span className="tooltip-label">Cuota fija compañía</span>
                        </span>
                        <fieldset className="icon-wrapper data" data-label="€/Mes">
                          <input type="text" inputMode="decimal" id="cuotaMensualComercializadora" className="" />
                        </fieldset>
                      </fieldset>
                    </fieldset>


                    

                  </fieldset>  

                </fieldset>

                <fieldset>
                  <span className="size-l">CONSUMOS, EXCEDENTES, TARIFAS E IVA</span>

                  <fieldset id="fieldsetCamposTarifasEnergia" className="columns col-lg-7">

                    <span className="size-l">Tarifas</span>

                    <fieldset id="trTarifaAnalisisEnergiaP1">
                      <label htmlFor="trTarifaAnalisisEnergiaP1">Tarifa P1</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP1" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trTarifaAnalisisEnergiaP2">
                      <label htmlFor="trTarifaAnalisisEnergiaP2">Tarifa P2</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP2" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trTarifaAnalisisEnergiaP3">
                      <label htmlFor="trTarifaAnalisisEnergiaP3">Tarifa P3</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP3" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trTarifaAnalisisEnergiaP4">
                      <label htmlFor="trTarifaAnalisisEnergiaP4">Tarifa P4</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP4" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trTarifaAnalisisEnergiaP5">
                      <label htmlFor="trTarifaAnalisisEnergiaP5">Tarifa P5</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP5" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                    <fieldset id="trTarifaAnalisisEnergiaP6">
                      <label htmlFor="trTarifaAnalisisEnergiaP6">Tarifa P6</label>
                      <fieldset className="icon-wrapper data" data-label="€/kWh">
                        <input id="tarifaAnalisisEnergiaP6" type="text" inputMode="decimal"/>
                      </fieldset>
                    </fieldset>

                  </fieldset>

                  <fieldset id="fieldsetCamposConsumos">                    

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM1" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 1</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>
                      

                      <fieldset id="trConsumosMes1P1">
                        <label htmlFor="trConsumosMes1P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes1P2">
                        <label htmlFor="trConsumosMes1P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes1P3">
                        <label htmlFor="trConsumosMes1P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes1P4">
                        <label htmlFor="trConsumosMes1P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes1P5">
                        <label htmlFor="trConsumosMes1P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes1P6">
                        <label htmlFor="trConsumosMes1P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes1P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetTarifasM1" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes1P1">
                        <label htmlFor="trTarifaMes1P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes1P2">
                        <label htmlFor="trTarifaMes1P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes1P3">
                        <label htmlFor="trTarifaMes1P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes1P4">
                        <label htmlFor="trTarifaMes1P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes1P5">
                        <label htmlFor="trTarifaMes1P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes1P6">
                        <label htmlFor="trTarifaMes1P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes1P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM1" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes1">
                        <label htmlFor="trExcedentesMes1">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>                    

                      <fieldset id="trTarifaExcedentesMes1">
                        <label htmlFor="trTarifaExcedentesMes1">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes1">
                        <label htmlFor="trIVAMes1">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM2" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 2</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes2P1">
                        <label htmlFor="trConsumosMes2P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes2P2">
                        <label htmlFor="trConsumosMes2P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes2P3">
                        <label htmlFor="trConsumosMes2P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes2P4">
                        <label htmlFor="trConsumosMes2P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes2P5">
                        <label htmlFor="trConsumosMes2P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes2P6">
                        <label htmlFor="trConsumosMes2P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes2P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM2" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes2P1">
                        <label htmlFor="trTarifaMes2P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes2P2">
                        <label htmlFor="trTarifaMes2P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes2P3">
                        <label htmlFor="trTarifaMes2P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes2P4">
                        <label htmlFor="trTarifaMes2P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes2P5">
                        <label htmlFor="trTarifaMes2P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes2P6">
                        <label htmlFor="trTarifaMes2P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes2P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM2" className="columns col-lg-4">

                      <span className="size-l"></span>
                      
                      <fieldset id="trExcedentesMes2">
                        <label htmlFor="trExcedentesMes2">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes2">
                        <label htmlFor="trTarifaExcedentesMes2">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes2">
                        <label htmlFor="trIVAMes2">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM3" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 3</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes3P1">
                        <label htmlFor="trConsumosMes3P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes3P2">
                        <label htmlFor="trConsumosMes3P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes3P3">
                        <label htmlFor="trConsumosMes3P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes3P4">
                        <label htmlFor="trConsumosMes3P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes3P5">
                        <label htmlFor="trConsumosMes3P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes3P6">
                        <label htmlFor="trConsumosMes3P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes3P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetTarifasM3" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes3P1">
                        <label htmlFor="trTarifaMes3P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes3P2">
                        <label htmlFor="trTarifaMes3P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes3P3">
                        <label htmlFor="trTarifaMes3P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes3P4">
                        <label htmlFor="trTarifaMes3P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes3P5">
                        <label htmlFor="trTarifaMes3P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes3P6">
                        <label htmlFor="trTarifaMes3P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes3P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM3" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes3">
                        <label htmlFor="trExcedentesMes3">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes3">
                        <label htmlFor="trTarifaExcedentesMes3">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                      
                      <fieldset id="trIVAMes3">
                        <label htmlFor="trIVAMes3">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM4" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 4</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes4P1">
                        <label htmlFor="trConsumosMes4P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes4P2">
                        <label htmlFor="trConsumosMes4P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes4P3">
                        <label htmlFor="trConsumosMes4P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes4P4">
                        <label htmlFor="trConsumosMes4P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes4P5">
                        <label htmlFor="trConsumosMes4P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes4P6">
                        <label htmlFor="trConsumosMes4P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes4P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    </fieldset>

                    <fieldset id="fieldsetTarifasM4" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes4P1">
                        <label htmlFor="trTarifaMes4P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes4P2">
                        <label htmlFor="trTarifaMes4P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes4P3">
                        <label htmlFor="trTarifaMes4P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes4P4">
                        <label htmlFor="trTarifaMes4P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes4P5">
                        <label htmlFor="trTarifaMes4P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes4P6">
                        <label htmlFor="trTarifaMes4P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes4P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM4" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes4">
                        <label htmlFor="trExcedentesMes4">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes4">
                        <label htmlFor="trTarifaExcedentesMes4">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes4">
                        <label htmlFor="trIVAMes4">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM5" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 5</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes5P1">
                        <label htmlFor="trConsumosMes5P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes5P2">
                        <label htmlFor="trConsumosMes5P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes5P3">
                        <label htmlFor="trConsumosMes5P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes5P4">
                        <label htmlFor="trConsumosMes5P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes5P5">
                        <label htmlFor="trConsumosMes5P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes5P6">
                        <label htmlFor="trConsumosMes5P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes5P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetTarifasM5" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes5P1">
                        <label htmlFor="trTarifaMes5P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes5P2">
                        <label htmlFor="trTarifaMes5P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes5P3">
                        <label htmlFor="trTarifaMes5P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes5P4">
                        <label htmlFor="trTarifaMes5P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes5P5">
                        <label htmlFor="trTarifaMes5P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes5P6">
                        <label htmlFor="trTarifaMes5P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes5P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM5" className="columns col-lg-4">

                      <span className="size-l"></span>
                      
                      <fieldset id="trExcedentesMes5">
                        <label htmlFor="trExcedentesMes5">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes5">
                        <label htmlFor="trTarifaExcedentesMes5">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes5">
                        <label htmlFor="trIVAMes5">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM6" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 6</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes6P1">
                        <label htmlFor="trConsumosMes6P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes6P2">
                        <label htmlFor="trConsumosMes6P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes6P3">
                        <label htmlFor="trConsumosMes6P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes6P4">
                        <label htmlFor="trConsumosMes6P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes6P5">
                        <label htmlFor="trConsumosMes6P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes6P6">
                        <label htmlFor="trConsumosMes6P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes6P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetTarifasM6" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes6P1">
                        <label htmlFor="trTarifaMes6P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes6P2">
                        <label htmlFor="trTarifaMes6P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes6P3">
                        <label htmlFor="trTarifaMes6P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes6P4">
                        <label htmlFor="trTarifaMes6P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes6P5">
                        <label htmlFor="trTarifaMes6P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes6P6">
                        <label htmlFor="trTarifaMes6P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes6P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM6" className="columns col-lg-4">

                      <span className="size-l"></span>
                      
                      <fieldset id="trExcedentesMes6">
                        <label htmlFor="trExcedentesMes6">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes6">
                        <label htmlFor="trTarifaExcedentesMes6">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes6">
                        <label htmlFor="trIVAMes6">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM7" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 7</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes7P1">
                        <label htmlFor="trConsumosMes7P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes7P2">
                        <label htmlFor="trConsumosMes7P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes7P3">
                        <label htmlFor="trConsumosMes7P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes7P4">
                        <label htmlFor="trConsumosMes7P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes7P5">
                        <label htmlFor="trConsumosMes7P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes7P6">
                        <label htmlFor="trConsumosMes7P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes7P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM7" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes7P1">
                        <label htmlFor="trTarifaMes7P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes7P2">
                        <label htmlFor="trTarifaMes7P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes7P3">
                        <label htmlFor="trTarifaMes7P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes7P4">
                        <label htmlFor="trTarifaMes7P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes7P5">
                        <label htmlFor="trTarifaMes7P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes7P6">
                        <label htmlFor="trTarifaMes7P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes7P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM7" className="columns col-lg-4">

                      <span className="size-l"></span>
                      
                      <fieldset id="trExcedentesMes7">
                        <label htmlFor="trExcedentesMes7">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes7" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes7">
                        <label htmlFor="trTarifaExcedentesMes7">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes7" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes7">
                        <label htmlFor="trIVAMes7">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes7" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM8" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 8</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>
                      
                      <fieldset id="trConsumosMes8P1">
                        <label htmlFor="trConsumosMes8P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes8P2">
                        <label htmlFor="trConsumosMes8P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes8P3">
                        <label htmlFor="trConsumosMes8P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes8P4">
                        <label htmlFor="trConsumosMes8P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes8P5">
                        <label htmlFor="trConsumosMes8P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes8P6">
                        <label htmlFor="trConsumosMes8P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes8P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM8" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes8P1">
                        <label htmlFor="trTarifaMes8P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes8P2">
                        <label htmlFor="trTarifaMes8P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes8P3">
                        <label htmlFor="trTarifaMes8P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes8P4">
                        <label htmlFor="trTarifaMes8P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes8P5">
                        <label htmlFor="trTarifaMes8P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes8P6">
                        <label htmlFor="trTarifaMes8P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes8P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM8" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes8">
                        <label htmlFor="trExcedentesMes8">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes8" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes8">
                        <label htmlFor="trTarifaExcedentesMes8">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes8" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes8">
                        <label htmlFor="trIVAMes8">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes8" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM9" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 9</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes9P1">
                        <label htmlFor="trConsumosMes9P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes9P2">
                        <label htmlFor="trConsumosMes9P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes9P3">
                        <label htmlFor="trConsumosMes9P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes9P4">
                        <label htmlFor="trConsumosMes9P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes9P5">
                        <label htmlFor="trConsumosMes9P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes9P6">
                        <label htmlFor="trConsumosMes9P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes9P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM9" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes9P1">
                        <label htmlFor="trTarifaMes9P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes9P2">
                        <label htmlFor="trTarifaMes9P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes9P3">
                        <label htmlFor="trTarifaMes9P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes9P4">
                        <label htmlFor="trTarifaMes9P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes9P5">
                        <label htmlFor="trTarifaMes9P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes9P6">
                        <label htmlFor="trTarifaMes9P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes9P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM9" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes9">
                        <label htmlFor="trExcedentesMes9">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes9" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes9">
                        <label htmlFor="trTarifaExcedentesMes3">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes9" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes9">
                        <label htmlFor="trIVAMes9">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes9" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM10" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 10</span>
                        <a href="#BotoneraFormulario" className="link">Bajar</a>
                      </fieldset>

                      <fieldset id="trConsumosMes10P1">
                        <label htmlFor="trConsumosMes10P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes10P2">
                        <label htmlFor="trConsumosMes10P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes10P3">
                        <label htmlFor="trConsumosMes10P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes10P4">
                        <label htmlFor="trConsumosMes10P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes10P5">
                        <label htmlFor="trConsumosMes10P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes10P6">
                        <label htmlFor="trConsumosMes10P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes10P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM10" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes10P1">
                        <label htmlFor="trTarifaMes10P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes10P2">
                        <label htmlFor="trTarifaMes10P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes10P3">
                        <label htmlFor="trTarifaMes10P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes10P4">
                        <label htmlFor="trTarifaMes10P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes10P5">
                        <label htmlFor="trTarifaMes10P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes10P6">
                        <label htmlFor="trTarifaMes10P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes10P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM10" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes10">
                        <label htmlFor="trExcedentesMes10">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes10" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes10">
                        <label htmlFor="trTarifaExcedentesMes10">Preccio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes10" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes10">
                        <label htmlFor="trIVAMes10">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes10" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM11" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 11</span>
                        <a href="#cabeceraHelias" className="link">Subir</a>
                      </fieldset>
                      
                      <fieldset id="trConsumosMes11P1">
                        <label htmlFor="trConsumosMes11P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes11P2">
                        <label htmlFor="trConsumosMes11P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes11P3">
                        <label htmlFor="trConsumosMes11P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes11P4">
                        <label htmlFor="trConsumosMes11P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes11P5">
                        <label htmlFor="trConsumosMes11P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes11P6">
                        <label htmlFor="trConsumosMes11P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes11P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM11" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes11P1">
                        <label htmlFor="trTarifaMes11P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes11P2">
                        <label htmlFor="trTarifaMes11P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes11P3">
                        <label htmlFor="trTarifaMes11P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes11P4">
                        <label htmlFor="trTarifaMes11P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes11P5">
                        <label htmlFor="trTarifaMes11P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes11P6">
                        <label htmlFor="trTarifaMes11P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes11P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM11" className="columns col-lg-4">

                      <span className="size-l"></span>
                      
                      <fieldset id="trExcedentesMes11">
                        <label htmlFor="trExcedentesMes11">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes11" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes11">
                        <label htmlFor="trTarifaExcedentesMes11">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes11" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trIVAMes11">
                        <label htmlFor="trIVAMes11">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes11" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                    <fieldset id="fieldsetConsumosM12" className="columns col-lg-7">

                      <fieldset>
                        <span className="size-l">Mes 12</span>
                        <a href="#cabeceraHelias" className="link">Subir</a>
                      </fieldset>
                      
                      <fieldset id="trConsumosMes12P1">
                        <label htmlFor="trConsumosMes12P1">Consumo - P1</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes12P2">
                        <label htmlFor="trConsumosMes12P2">Consumo - P2</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes12P3">
                        <label htmlFor="trConsumosMes12P3">Consumo - P3</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes12P4">
                        <label htmlFor="trConsumosMes12P4">Consumo - P4</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes12P5">
                        <label htmlFor="trConsumosMes12P5">Consumo - P5</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trConsumosMes12P6">
                        <label htmlFor="trConsumosMes12P6">Consumo - P6</label>
                        <fieldset className="icon-wrapper data" data-label="kWh">
                          <input id="ConsumoMes12P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <fieldset id="fieldsetTarifasM12" className="columns col-lg-7">

                      <span className="size-l"></span>

                      <fieldset id="trTarifaMes12P1">
                        <label htmlFor="trTarifaMes12P1">Tarifa - P1</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P1" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes12P2">
                        <label htmlFor="trTarifaMes12P2">Tarifa - P2</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P2" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes12P3">
                        <label htmlFor="trTarifaMes12P3">Tarifa - P3</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P3" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes12P4">
                        <label htmlFor="trTarifaMes12P4">Tarifa - P4</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P4" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes12P5">
                        <label htmlFor="trTarifaMes12P5">Tarifa - P5</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P5" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaMes12P6">
                        <label htmlFor="trTarifaMes12P6">Tarifa - P6</label>
                        <fieldset className="icon-wrapper data" data-label="€/kWh">
                          <input id="TarifaMes12P6" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                    </fieldset>

                    <fieldset id="fieldsetExcedentesIVAM12" className="columns col-lg-4">

                      <span className="size-l"></span>

                      <fieldset id="trExcedentesMes12">
                        <label htmlFor="trExcedentesMes12">Excedente</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="ExcedenteMes12" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>

                      <fieldset id="trTarifaExcedentesMes12">
                        <label htmlFor="trTarifaExcedentesMes12">Precio de compra</label>
                        <fieldset className="icon-wrapper data" data-label="kW">
                          <input id="TarifaExcedentesMes12" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                      
                      <fieldset id="trIVAMes12">
                        <label htmlFor="trIVAMes12">% IVA</label>
                        <fieldset className="icon-wrapper data" data-label="%">
                          <input id="IVAMes12" type="text" inputMode="decimal"/>
                        </fieldset>
                      </fieldset>
                    
                    </fieldset>

                    <ul className="horizontal center">──────────────────────────────────────────────────────────────────────────────────────────</ul>       

                  </fieldset>

                </fieldset>

                <fieldset id="BotoneraFormulario" className="horizontal">
                  <button className="button tertiary full-width" onClick={() => guardarBorrador()}>Guardar borrador</button>
                  <button className="button primary full-width" onClick={() => verificarTarifa()}>Realizar análisis</button>
                </fieldset>

              </fieldset>

            </details>

          </div>

        </div>
        
        <button id="BotonEnviarAnalisis" className="button primary delete full-width hidden" style={{height: "48px", alignSelf: "flex-end", marginBottom: "20px", marginTop: "18px"}} onClick={() => advisoryCommonJS.enviarResumenAnalisisFacturas()}></button>
        
        <Last12BillsAnalysis/>

      </div>
            
    </div>   
  )
}

export default FeesAnalyzer